import { Cloud, Server, Lock } from "lucide-react";
import { motion } from "framer-motion";

const opts = [
    { icon: Cloud, t: "Colecle Cloud", d: "Fully managed SaaS. Instant provisioning, automated backups, elastic scale, 99.9% SLA.", label: "Recommended" },
    { icon: Server, t: "Private Cloud", d: "Dedicated tenant on your preferred cloud provider (AWS, Azure, GCP) with VPC isolation.", label: "Regulated Industries" },
    { icon: Lock, t: "On-Premises", d: "Air-gapped deployment inside your data centre for sovereign, high-security environments.", label: "Government & Defence" },
];

export default function Deployment() {
    return (
        <section data-testid="deployment-section" className="bg-[#F7F9FC]">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
                <div className="grid lg:grid-cols-12 gap-8 mb-14">
                    <div className="lg:col-span-8">
                        <div className="eyebrow">Deployment Options</div>
                        <h2 className="headline text-4xl md:text-5xl lg:text-6xl mt-4 text-navy">
                            Deploy Colecle <em className="not-italic text-[#2563EB]">your way</em>.
                        </h2>
                    </div>
                </div>
                <div className="grid md:grid-cols-3 gap-6">
                    {opts.map((o, i) => (
                        <motion.div
                            key={o.t}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="bg-white border border-slate-200 rounded-2xl p-8 hover:border-navy transition group"
                        >
                            <div className="flex items-center justify-between mb-6">
                                <div className="w-12 h-12 rounded-full bg-navy text-[#E8B923] flex items-center justify-center">
                                    <o.icon className="w-5 h-5" />
                                </div>
                                <span className="font-mono text-[10px] tracking-widest uppercase text-slate-500 border border-slate-200 rounded-full px-2.5 py-1">{o.label}</span>
                            </div>
                            <h3 className="font-serif text-2xl text-navy">{o.t}</h3>
                            <p className="text-slate-600 text-sm mt-3 leading-relaxed">{o.d}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
